import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ReactToggle from 'react-toggle';
import { jsx as _jsx } from "react/jsx-runtime";
function Toggle(_ref) {
  let {
    checked,
    onChange,
    uiContext = 'default',
    icons = false,
    disabled = false,
    ariaLabel = '',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "react-toggle-wrapper",
    role: "switch",
    "aria-checked": checked,
    "aria-label": ariaLabel,
    tabIndex: 0,
    children: /*#__PURE__*/_jsx(ReactToggle, {
      "data-cmp": "toggle",
      icons: icons,
      checked: checked,
      onChange: onChange,
      className: clsx({
        'react-toggle--inversed': uiContext === 'dark',
        'react-toggle--lg': uiContext === 'lg'
      }),
      disabled: disabled,
      "aria-label": ariaLabel,
      ...rest
    })
  });
}
export default Toggle;